'use es6';

import PortalIdParser from 'PortalIdParser';
import { getReportDefinition } from 'reporting-data/report/reportGetters';
import { getId, getTemplateKey } from '../../data/schemas/reportSchema';
import { isAttributionLike, isSnowflake, isJourney, isJourneyLikeExternal } from '../../lib/report-logic';
import { getAttributionBuilderPathEnding } from './attributionBuilderUtils';
import { maybePassJourneyViaLocalStorage } from './journeyLocalStorage';
export const encodeReport = report => {
  try {
    return btoa(encodeURIComponent(JSON.stringify(report)));
  } catch (err) {
    return null;
  }
};
const encodeReportDefinition = report => {
  try {
    const reportDefinition = getReportDefinition(report);
    return encodeURIComponent(JSON.stringify(reportDefinition));
  } catch (err) {
    return null;
  }
};
export const getBuilderUrl = ({
  loadConfig,
  report
}) => {
  const portalId = PortalIdParser.get();
  const reportId = getId(report);
  const template = getTemplateKey(report);
  let builderUrl = '';
  let remainingUrl = '';

  //attribution builder
  if (isAttributionLike(report)) {
    builderUrl = `/attribution-builder/${portalId}`;
    remainingUrl = reportId ? `/contact?reportId=${reportId}` : `/${getAttributionBuilderPathEnding(report)}`;
  }
  //snowflake builder
  else if (isSnowflake(report)) {
    builderUrl = `/advanced-builder/${portalId}`;
    remainingUrl = reportId ? `/report/${reportId}?` : loadConfig ? `?definition=${encodeReportDefinition(report)}` : `?template=${template}`;
  }

  // journey builder
  else if (isJourney(report) || isJourneyLikeExternal(report)) {
    const useStoredConfig = maybePassJourneyViaLocalStorage(report, {
      loadConfig
    });
    builderUrl = `/journey-builder/${portalId}`;
    remainingUrl = reportId ? `?reportId=${reportId}` : template && !useStoredConfig ? `?templateKey=${template}` : `/`;
  }
  //single object builder
  else {
    builderUrl = `/report-builder/${portalId}`;
    remainingUrl = reportId ? `/report/${reportId}` : loadConfig ? `/load-config/${encodeReport(report)}` : `/template/${template}`;
  }
  const relativeUrl = `${builderUrl}${remainingUrl}`;
  return new URL(relativeUrl, window.location);
};
const openReportInBuilder = ({
  dashboardId,
  loadConfig,
  report,
  openInNewTab,
  whichFlow
}) => {
  const url = getBuilderUrl({
    loadConfig,
    report
  });
  if (dashboardId) {
    url.searchParams.append('dashboardId', dashboardId);
  }
  if (whichFlow) {
    url.searchParams.append('whichFlow', whichFlow);
  }
  if (openInNewTab) {
    window.open(url, '_blank');
  } else {
    window.location = url;
  }
};
export default openReportInBuilder;